import { render, staticRenderFns } from "./AutopsyTab.vue?vue&type=template&id=6c150d50&scoped=true"
import script from "./AutopsyTab.vue?vue&type=script&lang=js"
export * from "./AutopsyTab.vue?vue&type=script&lang=js"
import style0 from "./AutopsyTab.vue?vue&type=style&index=0&id=6c150d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c150d50",
  null
  
)

export default component.exports